import api from '@/services/api'
import type { OhlcvTuple } from '@/utils/types'
import type {
  DexPoolResponse,
  DexPriceResponse,
  DexContractResponse,
  DexAssetPoolResponse,
  DexScreenerPoolItem,
  GeckoTerminalPoolItem,
  DexPoolChain,
} from './types'
import { DEX_SCREENER_CHAIN_MAP, GECKO_TERMINAL_CHAIN_MAP } from './types'

export const DexPoolsV2Service = {
  fetchPools(query?: string | null) {
    return api.get<DexPoolResponse[]>('/v2/dex/', { params: { query } })
  },
  fetchPool(address: string, cexName: string) {
    return api.get<DexPoolResponse>(`/v2/dex/${address}/${cexName}`)
  },
  fetchPrice(address: string) {
    return api.get<DexPriceResponse>(`/v2/dex/price/${address}`)
  },
  fetchOhlcv(chain: string, address: string) {
    return api.get<OhlcvTuple[]>(`/v2/dex/ohlcv/${chain}/${address}`)
  },
  fetchTicks(ctr: string, pool: string, chain: string) {
    return api.get(`/v2/dex/${ctr}/${pool}/${chain}/ticks`)
  },
  fetchGmgnTicks(ctr: string, chain: string) {
    return api.get(`/v2/dex/${ctr}/${chain}/gmgn-ticks`)
  },
  putTokenAddress(exchange: string, asset: string, chain: string, ctr: string, marketType: string = 'swap') {
    return api.put(`/v2/dex/${exchange}/${asset}/${chain}/${ctr}?market_type=${marketType}`)
  },
  fetchContract(asset: string, exchange: string, marketType: string = 'swap') {
    asset = asset.toUpperCase()
    return api.get<DexContractResponse>(`/v2/dex/${asset}/${exchange}/contract?market_type=${marketType}`)
  },
  fetchAssetPoolByAddress(pool: string, chainId: string) {
    return api.get<DexAssetPoolResponse>(`/v2/dex/pool/${pool}/${chainId}`)
  },
  fetchDexScreenerPools(chainId: DexPoolChain, contractAddress: string) {
    const mapped = DEX_SCREENER_CHAIN_MAP[chainId.toLowerCase() as DexPoolChain]
    return api.get<DexScreenerPoolItem[]>(`/v2/dex/pools/dexscreener/${mapped}/${contractAddress}`)
  },
  fetchGeckoTerminalPools(chainId: DexPoolChain, contractAddress: string) {
    const mapped = GECKO_TERMINAL_CHAIN_MAP[chainId.toLowerCase() as DexPoolChain]
    return api.get<GeckoTerminalPoolItem[]>(
      `/v2/dex/pools/geckoterminal/${mapped}/${contractAddress}`,
    )
  },
  putV4PoolMeta(chain: string, poolId: string) {
    return api.put(`/v2/dex/v4-meta/${chain}/${poolId}`)
  },
}
